import { render, staticRenderFns } from "./HomeHowTo.vue?vue&type=template&id=2c08b293"
import script from "./HomeHowTo.vue?vue&type=script&lang=js"
export * from "./HomeHowTo.vue?vue&type=script&lang=js"
import style0 from "./HomeHowTo.vue?vue&type=style&index=0&id=2c08b293&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports